// import React, { useState, useEffect } from 'react';
// import './Downloads.css';

// function Downloads() {
//   const [downloads, setDownloads] = useState([]);
//   const [stats, setStats] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [filter, setFilter] = useState('all');
//   const [search, setSearch] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [total, setTotal] = useState(0);

//   useEffect(() => {
//     fetchDownloads();
//   }, [filter, currentPage, search]);

//   const fetchDownloads = async () => {
//     const token = localStorage.getItem('adminToken');
//     setLoading(true);
//     try {
//       const url = new URL(`${import.meta.env.VITE_API_URL}/api/admin/downloads/insights`);
//       url.searchParams.append('page', currentPage);
//       url.searchParams.append('limit', 20);
//       if (filter !== 'all') url.searchParams.append('type', filter);
//       if (search) url.searchParams.append('search', search);
      
//       const response = await fetch(url, {
//         headers: { 'Authorization': `Bearer ${token}` }
//       });
//       const data = await response.json();
      
//       if (data.success) {
//         setDownloads(data.data);
//         setStats(data.stats);
//         setTotalPages(data.totalPages);
//         setTotal(data.total);
//       }
//     } catch (error) {
//       console.error('Error fetching downloads:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getTypeLabel = (type) => {
//     const labels = {
//       'case-study': 'Case Study',
//       'blog': 'Blog',
//       'whitepaper': 'Whitepaper'
//     };
//     return labels[type] || type;
//   };

//   const getTypeBadgeClass = (type) => {
//     const classes = {
//       'case-study': 'type-badge-case-study',
//       'blog': 'type-badge-blog',
//       'whitepaper': 'type-badge-whitepaper'
//     };
//     return classes[type] || '';
//   };

//   const formatDate = (date) => {
//     return new Date(date).toLocaleString();
//   };

//   const exportToCSV = () => {
//     const headers = ['Name', 'Email', 'Insight Title', 'Type', 'Downloaded At', 'IP Address'];
//     const csvData = downloads.map(d => [
//       d.name,
//       d.email,
//       d.insightTitle,
//       getTypeLabel(d.insightType),
//       formatDate(d.downloadedAt),
//       d.ipAddress || 'N/A'
//     ]);
    
//     const csvContent = [headers, ...csvData].map(row => row.join(',')).join('\n');
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `download-history-${new Date().toISOString().split('T')[0]}.csv`;
//     a.click();
//     window.URL.revokeObjectURL(url);
//   };

//   if (loading && downloads.length === 0) {
//     return (
//       <div className="loading-container">
//         <div className="loading-spinner"></div>
//         <p>Loading download history...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="download-history">
//       <div className="admin-header">
//         <h1>Download History</h1>
//         <button className="export-btn" onClick={exportToCSV}>
//           📊 Export to CSV
//         </button>
//       </div>

//       {/* Stats Cards */}
//       {stats && (
//         <div className="stats-grid">
//           <div className="stat-card">
//             <div className="stat-value">{stats.total}</div>
//             <div className="stat-label">Total Downloads</div>
//           </div>
//           <div className="stat-card">
//             <div className="stat-value">{stats.today || 0}</div>
//             <div className="stat-label">Today</div>
//           </div>
//           <div className="stat-card">
//             <div className="stat-value">{stats.thisWeek || 0}</div>
//             <div className="stat-label">This Week</div>
//           </div>
//           <div className="stat-card">
//             <div className="stat-value">{stats.thisMonth || 0}</div>
//             <div className="stat-label">This Month</div>
//           </div>
//         </div>
//       )}

//       {/* Filters */}
//       <div className="filters-bar">
//         <div className="filter-group">
//           <label>Filter by Type:</label>
//           <select value={filter} onChange={(e) => setFilter(e.target.value)}>
//             <option value="all">All Types</option>
//             <option value="case-study">Case Studies</option>
//             <option value="blog">Blogs</option>
//             <option value="whitepaper">Whitepapers</option>
//           </select>
//         </div>
        
//         <div className="filter-group">
//           <label>Search:</label>
//           <input
//             type="text"
//             placeholder="Search by name, email, or title..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             className="search-input"
//           />
//         </div>
        
//         <div className="filter-group">
//           <button className="refresh-btn" onClick={fetchDownloads}>
//             🔄 Refresh
//           </button>
//         </div>
//       </div>

//       {/* Type Breakdown */}
//       {stats && stats.byType && stats.byType.length > 0 && (
//         <div className="type-breakdown">
//           <h3>Downloads by Type</h3>
//           <div className="type-chart">
//             {stats.byType.map(item => (
//               <div key={item._id} className="type-bar">
//                 <span className="type-label">{getTypeLabel(item._id)}</span>
//                 <div className="bar-container">
//                   <div 
//                     className={`bar-fill ${getTypeBadgeClass(item._id)}`}
//                     style={{ width: `${(item.count / stats.total) * 100}%` }}
//                   />
//                 </div>
//                 <span className="bar-count">{item.count}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Downloads Table */}
//       <div className="data-table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>Name</th>
//               <th>Email</th>
//               <th>Insight Title</th>
//               <th>Type</th>
//               <th>Downloaded At</th>
//               <th>IP Address</th>
//             </tr>
//           </thead>
//           <tbody>
//             {downloads.map((download) => (
//               <tr key={download._id}>
//                 <td>{download.name}</td>
//                 <td>{download.email}</td>
//                 <td>{download.insightTitle}</td>
//                 <td>
//                   <span className={`type-badge ${getTypeBadgeClass(download.insightType)}`}>
//                     {getTypeLabel(download.insightType)}
//                   </span>
//                 </td>
//                 <td>{formatDate(download.downloadedAt)}</td>
//                 <td>{download.ipAddress || 'N/A'}</td>
//               </tr>
//             ))}
//             {downloads.length === 0 && (
//               <tr>
//                 <td colSpan="6" className="no-data">
//                   No download records found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="pagination">
//           <button
//             onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
//             disabled={currentPage === 1}
//             className="page-btn"
//           >
//             ← Previous
//           </button>
//           <span className="page-info">
//             Page {currentPage} of {totalPages} ({total} total)
//           </span>
//           <button
//             onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
//             disabled={currentPage === totalPages}
//             className="page-btn"
//           >
//             Next →
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }

// export default Downloads;



import React, { useState, useEffect } from 'react';
import './Downloads.css';

function Downloads() {
  const [downloads, setDownloads] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    fetchDownloads();
  }, [filter, currentPage, search]);

  const fetchDownloads = async () => {
    const token = localStorage.getItem('adminToken');
    setLoading(true);
    try {
      const url = new URL(`${import.meta.env.VITE_API_URL}/api/admin/downloads/insights`);
      url.searchParams.append('page', currentPage);
      url.searchParams.append('limit', 20);
      if (filter !== 'all') url.searchParams.append('type', filter);
      if (search) url.searchParams.append('search', search);
      
      const response = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      
      if (data.success) {
        setDownloads(data.data);
        setStats(data.stats);
        setTotalPages(data.totalPages);
        setTotal(data.total);
      }
    } catch (error) {
      console.error('Error fetching downloads:', error);
    } finally {
      setLoading(false);
    }
  };

  const getTypeLabel = (type) => {
    const labels = {
      'case-study': 'Case Study',
      'blog': 'Blog',
      'whitepaper': 'Whitepaper'
    };
    return labels[type] || type;
  };

  const getTypeBadgeClass = (type) => {
    const classes = {
      'case-study': 'type-badge-case-study',
      'blog': 'type-badge-blog',
      'whitepaper': 'type-badge-whitepaper'
    };
    return classes[type] || '';
  };

  const getTypeColorClass = (type) => {
    const classes = {
      'case-study': 'case-study',
      'blog': 'blog',
      'whitepaper': 'whitepaper'
    };
    return classes[type] || '';
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleString();
  };

  const exportToCSV = () => {
    const headers = ['Name', 'Email', 'Insight Title', 'Type', 'Downloaded At', 'IP Address'];
    const csvData = downloads.map(d => [
      d.name,
      d.email,
      d.insightTitle,
      getTypeLabel(d.insightType),
      formatDate(d.downloadedAt),
      d.ipAddress || 'N/A'
    ]);
    
    const csvContent = [headers, ...csvData].map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `download-history-${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const clearSearch = () => {
    setSearch('');
    setCurrentPage(1);
  };

  if (loading && downloads.length === 0) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading download history...</p>
      </div>
    );
  }

  return (
    <div className="download-history">
      <div className="admin-header">
        <h1>Download History</h1>
        <button className="export-btn" onClick={exportToCSV}>
          📊 Export to CSV
        </button>
      </div>

      {/* Stats Cards */}
      {stats && (
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-value">{stats.total}</div>
            <div className="stat-label">Total Downloads</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{stats.today || 0}</div>
            <div className="stat-label">Today</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{stats.thisWeek || 0}</div>
            <div className="stat-label">This Week</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{stats.thisMonth || 0}</div>
            <div className="stat-label">This Month</div>
          </div>
        </div>
      )}

      {/* Type Breakdown Panel */}
      {stats && stats.byType && stats.byType.length > 0 && (
        <div className="type-breakdown-panel">
          <div className="panel-title">
            <h3>Downloads by Type</h3>
          </div>
          <div className="type-breakdown-body">
            <div className="type-chart">
              {stats.byType.map(item => (
                <div key={item._id} className="type-bar-item">
                  <div className="type-info">
                    <div className={`type-color-dot ${getTypeColorClass(item._id)}`} />
                    <span className="type-name">{getTypeLabel(item._id)}</span>
                    <span className="type-count">({item.count})</span>
                  </div>
                  <div className="bar-wrapper">
                    <div className="bar-track">
                      <div 
                        className={`bar-progress ${getTypeColorClass(item._id)}`}
                        style={{ width: `${(item.count / stats.total) * 100}%` }}
                      />
                    </div>
                    <span className="bar-percent">
                      {Math.round((item.count / stats.total) * 100)}%
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Unified Filter + Search Strip */}
      <div className="filter-search-strip">
        <div className="filter-section">
          <span className="filter-label">Filter by:</span>
          <div className="filter-chips">
            <button 
              className={`filter-chip ${filter === 'all' ? 'active' : ''}`}
              onClick={() => setFilter('all')}
            >
              All
            </button>
            <button 
              className={`filter-chip ${filter === 'case-study' ? 'active' : ''}`}
              onClick={() => setFilter('case-study')}
            >
              Case Studies
            </button>
            <button 
              className={`filter-chip ${filter === 'blog' ? 'active' : ''}`}
              onClick={() => setFilter('blog')}
            >
              Blogs
            </button>
            <button 
              className={`filter-chip ${filter === 'whitepaper' ? 'active' : ''}`}
              onClick={() => setFilter('whitepaper')}
            >
              Whitepapers
            </button>
          </div>
        </div>
        
        <div className="filter-divider"></div>
        
        <div className="search-section">
          <div className="search-input-wrapper">
            <span className="search-icon">🔍</span>
            <input
              type="text"
              placeholder="Search by name, email, or insight title..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {search && (
              <button className="clear-search" onClick={clearSearch}>
                ✕
              </button>
            )}
            <button className="refresh-btn" onClick={fetchDownloads}>
              Refresh
            </button>
          </div>
        </div>
      </div>

      {/* Downloads Table */}
      <div className="data-table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Insight Title</th>
              <th>Type</th>
              <th>Downloaded At</th>
              <th>IP Address</th>
            </tr>
          </thead>
          <tbody>
            {downloads.map((download) => (
              <tr key={download._id}>
                <td>{download.name}</td>
                <td>{download.email}</td>
                <td>{download.insightTitle}</td>
                <td>
                  <span className={`type-badge ${getTypeBadgeClass(download.insightType)}`}>
                    {getTypeLabel(download.insightType)}
                  </span>
                </td>
                <td>{formatDate(download.downloadedAt)}</td>
                <td>{download.ipAddress || 'N/A'}</td>
              </tr>
            ))}
            {downloads.length === 0 && (
              <tr>
                <td colSpan="6" className="no-data">
                  No download records found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
            disabled={currentPage === 1}
            className="page-btn"
          >
            ← Previous
          </button>
          <span className="page-info">
            Page {currentPage} of {totalPages} ({total} total)
          </span>
          <button
            onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
            disabled={currentPage === totalPages}
            className="page-btn"
          >
            Next →
          </button>
        </div>
      )}
    </div>
  );
}

export default Downloads;